import { render, staticRenderFns } from "./InfoAlertsClockEntries.vue?vue&type=template&id=6945a73b"
import script from "./InfoAlertsClockEntries.vue?vue&type=script&lang=js"
export * from "./InfoAlertsClockEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports